module.exports = __webpack_public_path__ + "img/Pellets-Preiszusammensetzung.9302ae8.png";